module.exports = __webpack_public_path__ + "img/BKAV1.708bd5ca.svg";